import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class MultiselectPillsComponent extends Component {
  get values() {
    return this.args?.values ?? [];
  }

  @action
  handlePillClick(item) {
    let values = [...this.values];
    if (values.includes(item)) {
      values = values.filter((_item) => _item !== item);
    } else {
      values.push(item);
    }
    this.args?.onSelect?.(values);
  }
}
